import { render, staticRenderFns } from "./tool-settings.vue?vue&type=template&id=482e238e&scoped=true"
import script from "./tool-settings.vue?vue&type=script&lang=js"
export * from "./tool-settings.vue?vue&type=script&lang=js"
import style0 from "./tool-settings.vue?vue&type=style&index=0&id=482e238e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482e238e",
  null
  
)

export default component.exports